import { Lead } from "./types";

export const mockLeads: Lead[] = [
  {
    id: '1',
    name: 'Sarah Johnson',
    title: 'VP of Operations',
    company: 'Acme Corp',
    email: 'sarah.j@acmecorp.com',
    phone: '+1 (555) 123-4567',
    source: 'LinkedIn',
    sourceDetail: 'LinkedIn InMail Campaign - Q1 2025',
    status: 'Hot',
    dealValue: 0,
    leadScore: 0,
    dateAdded: '1/15/2025',
    lastContact: '2 days ago',
    recentActions: [
      { id: '1', type: 'email', title: 'Sent demo video', performer: 'Anshul Jain', date: '1/31/2025' },
      { id: '2', type: 'message', title: 'Discussed pricing', performer: 'Anshul Jain', date: '1/29/2025' },
      { id: '3', type: 'call', title: 'Discovery call - 30 min', performer: 'Anshul Jain', date: '1/17/2025' }
    ],
    nextAction: { title: 'Follow-up call scheduled', date: '2/2/2025' }
  },
  {
    id: '2',
    name: 'Michael Chen',
    title: 'CTO',
    company: 'TechStart Inc',
    email: 'mchen@techstart.io',
    phone: '+1 (555) 234-5678',
    source: 'Website',
    sourceDetail: 'Contact Form - Pricing Page',
    status: 'Warm',
    dealValue: 0,
    leadScore: 0,
    dateAdded: '1/20/2025',
    lastContact: '1 day ago',
    recentActions: [
      { id: '1', type: 'email', title: 'Sent case studies', performer: 'Anshul Jain', date: '1/30/2025' },
      { id: '2', type: 'call', title: 'Discovery call', performer: 'Anshul Jain', date: '1/31/2025' }
    ],
    nextAction: { title: 'Send proposal', date: '2/1/2025' }
  },
  {
    id: '3',
    name: 'Jennifer Smith',
    title: 'CEO',
    company: 'Global Solutions',
    email: 'j.smith@globalsolutions.com',
    phone: '+1 (555) 345-6789',
    source: 'Referral',
    sourceDetail: 'Referred by Robert Brown',
    status: 'Hot',
    dealValue: 0,
    leadScore: 0,
    dateAdded: '1/28/2025',
    lastContact: 'Today',
    recentActions: [
      { id: '1', type: 'email', title: 'Demo request received', performer: 'Jennifer Smith', date: '1/31/2025' },
      { id: '2', type: 'ai', title: 'AI qualification call', performer: 'AI Assistant', date: '1/30/2025' }
    ],
    nextAction: { title: 'Product demo', date: '2/3/2025' }
  },
  {
    id: '4',
    name: 'Robert Brown',
    title: 'Product Manager',
    company: 'Innovation Labs',
    email: 'rbrown@innovationlabs.com',
    phone: '+1 (555) 456-7890',
    source: 'Google Ads',
    sourceDetail: 'Google Search Ads - "CRM Software"',
    status: 'Warm',
    dealValue: 0,
    leadScore: 0,
    dateAdded: '1/10/2025',
    lastContact: '3 days ago',
    recentActions: [
      { id: '1', type: 'message', title: 'Technical Q&A', performer: 'Anshul Jain', date: '1/28/2025' },
      { id: '2', type: 'call', title: 'Product walkthrough', performer: 'Anshul Jain', date: '1/24/2025' }
    ],
    nextAction: { title: 'Contract review', date: '2/5/2025' }
  },
  {
    id: '5',
    name: 'Emily Davis',
    title: 'Director of Sales',
    company: 'FastGrow Inc',
    email: 'emily.d@fastgrow.com',
    phone: '+1 (555) 567-8901',
    source: 'Cold Outreach',
    sourceDetail: 'Email Campaign - Enterprise Package',
    status: 'Warm',
    dealValue: 0,
    leadScore: 0,
    dateAdded: '1/18/2025',
    lastContact: '4 days ago',
    recentActions: [
      { id: '1', type: 'email', title: 'Follow-up email sent', performer: 'Anshul Jain', date: '1/27/2025' },
      { id: '2', type: 'call', title: 'Initial call', performer: 'Anshul Jain', date: '1/22/2025' }
    ],
    nextAction: { title: 'Schedule demo', date: '2/4/2025' }
  },
  {
    id: '6',
    name: 'David Wilson',
    title: 'CFO',
    company: 'Finance Plus',
    email: 'dwilson@financeplus.com',
    phone: '+1 (555) 678-9012',
    source: 'LinkedIn',
    sourceDetail: 'Connection Request Accepted',
    status: 'Cold',
    dealValue: 0,
    leadScore: 0,
    dateAdded: '1/25/2025',
    lastContact: '5 days ago',
    recentActions: [
      { id: '1', type: 'email', title: 'Introduction sent', performer: 'Anshul Jain', date: '1/26/2025' }
    ],
    nextAction: { title: 'Follow-up', date: '2/6/2025' }
  },
  {
    id: '7',
    name: 'Lisa Anderson',
    title: 'Marketing Director',
    company: 'Brand Builders',
    email: 'lisa.a@brandbuilders.com',
    phone: '+1 (555) 789-0123',
    source: 'Website',
    sourceDetail: 'Newsletter Signup',
    status: 'Warm',
    dealValue: 0,
    leadScore: 0,
    dateAdded: '1/22/2025',
    lastContact: '2 days ago',
    recentActions: [
      { id: '1', type: 'email', title: 'Content shared', performer: 'Anshul Jain', date: '1/29/2025' },
      { id: '2', type: 'call', title: 'Intro call', performer: 'Anshul Jain', date: '1/25/2025' }
    ],
    nextAction: { title: 'Send pricing', date: '2/2/2025' }
  },
  {
    id: '8',
    name: 'James Martinez',
    title: 'Head of IT',
    company: 'Tech Innovations',
    email: 'jmartinez@techinnovations.com',
    phone: '+1 (555) 890-1234',
    source: 'Referral',
    sourceDetail: 'Referred by Sarah Johnson',
    status: 'Hot',
    dealValue: 0,
    leadScore: 0,
    dateAdded: '1/29/2025',
    lastContact: '1 day ago',
    recentActions: [
      { id: '1', type: 'call', title: 'Technical discussion', performer: 'Anshul Jain', date: '1/30/2025' }
    ],
    nextAction: { title: 'Technical demo', date: '2/1/2025' }
  }
];